export function getHeaderCaseInsensitive(headers, name) {
  var _headers$key;
  const key = Object.keys(headers).find(key => key.toLowerCase() === name.toLowerCase());
  return key ? (_headers$key = headers[key]) !== null && _headers$key !== void 0 ? _headers$key : '' : '';
}